// Верхняя строка фильтров отчёта. На телефоне: выбор ресторана слева (растягивается, длинное
// название — с многоточием), колокольчик уведомлений со счётчиком справа — вместо пункта в нижней
// навигации. В браузере, PWA и Telegram одинаково (в Telegram строка ниже кнопок «Close»/меню —
// отступ задаёт StickyFiltersBar). На десктопе колокольчик в шапке — здесь только выбор ресторана.
import React from 'react';
import { Box, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import NotificationsIcon from '@mui/icons-material/NotificationsNone';
import UnreadBadge from './notifications/UnreadBadge';
import { NOTIFICATIONS_PATH, useDesktopLayout } from './layout/AppLayout';
import { useUnreadCount } from '../hooks/useUnreadCount';

function NotificationsBell() {
  const unread = useUnreadCount();
  return (
    <IconButton
      component={Link}
      to={NOTIFICATIONS_PATH}
      aria-label="Уведомления"
      sx={{
        flexShrink: 0,
        width: 44,
        height: 44,
        borderRadius: '10px',
        color: '#e4e4e7',
        backgroundColor: 'rgba(255,255,255,0.06)',
        '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' },
        '&.Mui-focusVisible': { outline: '2px solid #ff7043', outlineOffset: '2px' },
      }}
    >
      {/* Счётчик — в углу кнопки, а не поверх иконки (иначе «17» закрывает колокольчик) */}
      <UnreadBadge
        count={unread}
        badgeSx={{
          transform: 'scale(1) translate(85%, -75%)',
          '&.MuiBadge-invisible': { transform: 'scale(0) translate(85%, -75%)' },
        }}
      >
        <NotificationsIcon fontSize="small" />
      </UnreadBadge>
    </IconButton>
  );
}

export default function FiltersTopRow({ children }) {
  const desktop = useDesktopLayout();
  if (desktop) return children || null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', width: '100%' }}>
      <Box sx={{ flex: 1, minWidth: 0, display: 'flex', justifyContent: 'flex-start' }}>{children}</Box>
      <NotificationsBell />
    </Box>
  );
}
